"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencies = exports.testnet = exports.chainId = void 0;
const sepolia_1 = require("../../../erc20/chains/sepolia");
exports.chainId = 11155111;
exports.testnet = true;
exports.currencies = Object.assign({}, sepolia_1.supportedSepoliaERC20);
